import type { Dispatch, SetStateAction } from "react";
import { useSalon } from "../../../context/SalonContext";
import type { Employee, SalonService } from "../../../types/salon";

/**
 * The slice of SalonContext (a JS module) the staff form reads. The shared
 * `SalonContextType` declaration predates `servicing_staff` and
 * `refreshServices`, so the form types exactly what it uses here instead.
 */
export interface StaffFormSalonContext {
  businessInfo: ({ id: string } & Record<string, any>) | null;
  currentUser: Partial<Employee> | null;
  /** null until loaded; each service carries its `servicing_staff` rows. */
  services: SalonService[] | null;
  setEmployees: Dispatch<SetStateAction<Employee[] | null>>;
  refreshServices?: () => Promise<unknown>;
}

export const useStaffFormSalon = (): StaffFormSalonContext =>
  useSalon() as unknown as StaffFormSalonContext;
